module.exports = _.identity;